import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class AcertoCoparticipacaoService extends Service {
  async consultarTodosOsProtocolos () {
    let nomes = await this.getAcertoCoparticipacaoApi().consultarTodosOsProtocolos();
    return nomes || [];
  }

  async consultarTipos () {
    let tipos = await this.getAcertoCoparticipacaoApi().consultarTipos();
    return tipos || [];
  }

  async consultarEstados () {
    let estados = await this.getAcertoCoparticipacaoApi().consultarEstados();
    return estados || [];
  }

  async consultarGuias (numMatricula) {
    let guias = await this.getAcertoCoparticipacaoApi().consultarGuias(numMatricula);
    return guias || [];
  }
  async consultarGuiasCarteiraPrestador (numMatricula, seqPrestador) {
    let guias = await this.getAcertoCoparticipacaoApi().consultarGuiasCarteiraPrestador(numMatricula, seqPrestador);
    return guias || [];
  }

  async consultarDemonstrativos (numMatricula) {
    let demonstrativos = await this.getAcertoCoparticipacaoApi().consultarDemonstrativos(numMatricula);
    return demonstrativos || [];
  }

  async consultarProcedimentos (numProtocolo) {
    let procedimentos = await this.getAcertoCoparticipacaoApi().consultarProcedimentos(numProtocolo);
    return procedimentos || [];
  }

  async consultarAcertos (numProtocolo, numMatricula, codTipo, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal, seqPrestador) {
    let acertos = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    let result = await this.getAcertoCoparticipacaoApi().consultarAcertos(numProtocolo, numMatricula, codTipo, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal, seqPrestador);
    result.map(res => {
      const { numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codTipo, desTipo, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numProcesso, anoProcesso, valAcertoPrestador, indCancelado, historicos, seqPrestador, procedimentos, seqDivida, arquivos, numCnpjOrigemPagto, nomPrestador } = res;
      const numAnoProc = numProcesso + '/' + anoProcesso;
      brancoAcoes = indCancelado;
      if (codEstado === 4) {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        if (codEstado === 1) {
          tipoBotaoCancelamento = 'CANCELAR';
        } else {
          tipoBotaoCancelamento = 'NENHUM';
        }
      }
      acertos.push(Object.values({ numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, valAcertoPrestador, codTipo, desTipo, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numAnoProc, indCancelado, historicos, anoProcesso, numProcesso, seqPrestador, procedimentos, seqDivida, arquivos, numCnpjOrigemPagto, nomPrestador, tipoBotaoCancelamento, brancoAcoes }));
    });
    return acertos || [];
  }

  async consultarProcedimentosPagAntecipado (numMatricula, seqProcedimentosSelecionados) {
    let procedimentos = [];
    let result = await this.getAcertoCoparticipacaoApi().consultarProcedimentosPagAntecipado(numMatricula, seqProcedimentosSelecionados);
    result.map(res => {
      const { seqProcedimento, codItem, desItem, codTabela, desTabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, valRestaPagar, seqDivida, carteira, nome } = res;
      let tabela = codTabela.toString() + '-' + desTabela;
      let brancoAcoes = '';
      procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, valRestaPagar, seqDivida, brancoAcoes }));
    });
    return procedimentos || [];
  }
  async consultarProcedimentosDevolucao (numMatricula, codGuia, seqProcedimentosSelecionados) {
    let procedimentos = [];
    let result = await this.getAcertoCoparticipacaoApi().consultarProcedimentosDevolucao(numMatricula, codGuia, seqProcedimentosSelecionados);
    result.map(res => {
      const { seqProcedimento, codItem, desItem, codTabela, desTabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, carteira, nome, numCnpjOrigemPagto, dtaPagamento, indOdontologico } = res;
      let tabela = codTabela.toString() + '-' + desTabela;
      let origem = numCnpjOrigemPagto === '509968000148' ? 'Orçamento União' : 'Orçamento do Plano';
      let brancoAcoes = '';
      procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, dtaPagamento, origem, valProcedimento, valServidor, indOdontologico, brancoAcoes }));
    });
    return procedimentos || [];
  }
  async consultarProcedimentosCopartCalcIncorreto (numMatricula, codGuia, numDemonstrativo, seqPrestador, seqProcedimentosSelecionados) {
    let procedimentos = [];
    let result = await this.getAcertoCoparticipacaoApi().consultarProcedimentosCopartCalcIncorreto(numMatricula, codGuia, numDemonstrativo, seqPrestador, seqProcedimentosSelecionados);
    result.map(res => {
      const { seqProcedimento, codItem, desItem, codTabela, desTabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, seqDivida, carteira, nome, percCoparticipacao, indCopartCobradaTotal, valCoparticipacaoCalculada } = res;
      let tabela = codTabela.toString() + '-' + desTabela;
      let novoValor = 0;
      let valorAjuste = 0;
      let brancoAcoes = '';
      procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, indCopartCobradaTotal, percCoparticipacao, valProcedimento, valCoparticipacaoCalculada, valServidor, seqDivida, novoValor, valorAjuste, brancoAcoes }));
    });
    return procedimentos || [];
  }

  async incluirAcerto (acerto) {
    let result = await this.getAcertoCoparticipacaoApi().incluirAcerto(acerto);
    return result;
  }
  async alterarAcerto (acerto) {
    let result = await this.getAcertoCoparticipacaoApi().alterarAcerto(acerto);
    return result;
  }
  async processarAcertoPagAntecipado (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    const result = await this.getAcertoCoparticipacaoApi().processarAcertoPagAntecipado(numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim);
    return result;
  }
  async processarAcertoDevolucao (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    const result = await this.getAcertoCoparticipacaoApi().processarAcertoDevolucao(numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim);
    return result;
  }
  async processarAcertoCobrancaIndevida (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    const result = await this.getAcertoCoparticipacaoApi().processarAcertoCobrancaIndevida(numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim);
    return result;
  }
  async cancelarAcerto (numProtocolo, motivoCancelamento) {
    const result = await this.getAcertoCoparticipacaoApi().cancelarAcerto(numProtocolo, motivoCancelamento);
    return result;
  }
  async desfazerCancelamentoAcerto (numProtocolo) {
    const result = await this.getAcertoCoparticipacaoApi().desfazerCancelamentoAcerto(numProtocolo);
    return result;
  }
  async analisarAcerto (numProtocolo) {
    let result = await this.getAcertoCoparticipacaoApi().analisarAcerto(numProtocolo);
    return result;
  }
  async excluirAcerto (numProtocolo) {
    let result = await this.getAcertoCoparticipacaoApi().excluirAcerto(numProtocolo);
    return result;
  }
  async anexarArquivo (numProtocolo, nomeArquivo, txtObjetoGed) {
    let result = await this.getAcertoCoparticipacaoApi().anexarArquivo(numProtocolo, nomeArquivo, txtObjetoGed);
    return result;
  }
  async consultarArquivos (numProtocolo) {
    let result = await this.getAcertoCoparticipacaoApi().consultarArquivos(numProtocolo);
    return result;
  }
  async deletarArquivo (codArquivo) {
    let result = await this.getAcertoCoparticipacaoApi().deletarArquivo(codArquivo);
    return result;
  }
}
export default AcertoCoparticipacaoService;
